import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SetCursorPositionCommand from './setcursorpositioncommand';

export default class SetCursorPositionEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add( 'setcursorposition', new SetCursorPositionCommand( editor, 'setcursorposition' ) );
  }
}
